import { SUPPORTED_CURRENCY_CODES, DEFAULT_CURRENCY } from './currencies';
import { detectCurrencyFromTimezone } from '../components/common/common/getGeoInfo';

const OVERRIDE_KEY = 'withme_currency_override';
const ACTIVE_KEY = 'withme_currency';

const normalize = (code) => {
   if (!code || typeof code !== 'string') return null;
   const upper = code.trim().toUpperCase();
   return SUPPORTED_CURRENCY_CODES.includes(upper) ? upper : null;
};

const readLocalStorage = (key) => {
   try {
      return typeof window !== 'undefined' ? window.localStorage.getItem(key) : null;
   } catch (e) {
      return null;
   }
};

const writeLocalStorage = (key, value) => {
   try {
      if (typeof window === 'undefined') return;
      if (value == null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, value);
   } catch (e) {
      // quota / disabled storage — non fatal
   }
};

// Resolve active currency according to priority:
// 1. user override (localStorage)
// 2. geo-detected from timezone
// 3. fallback to GBP
export const resolveCurrency = () => {
   const override = normalize(readLocalStorage(OVERRIDE_KEY));
   if (override) return override;

   const active = normalize(readLocalStorage(ACTIVE_KEY));
   if (active) return active;

   const detected = normalize(detectCurrencyFromTimezone());
   if (detected) return detected;

   return DEFAULT_CURRENCY;
};

export const setCurrencyOverride = (code) => {
   const normalized = normalize(code);
   if (!normalized) return null;
   writeLocalStorage(OVERRIDE_KEY, normalized);
   writeLocalStorage(ACTIVE_KEY, normalized);
   return normalized;
};

export const clearCurrencyOverride = () => {
   writeLocalStorage(OVERRIDE_KEY, null);
};

export const getCurrencyOverride = () => normalize(readLocalStorage(OVERRIDE_KEY));
